export default {
  onboarding: {
    welcome: {
      title: "Benvenuto su",
      subtitle: "La tua app di riferimento per la ricerca sulle scommesse sportive: props, parlay e trend principali. È ora di salire di livello.",
      headline: "Trova la tua prossima scommessa",
      secondaryCta: "Hai già un account? Accedi",
    },
    leagues: {
      title: "Scegli le tue leghe preferite",
      subtitle: "Vedi prima le leghe che ti interessano ogni volta che apri l'app.",
    },
    location: {
      title: "Scopri cosa è disponibile vicino a te",
      subtitle: "Attiva la posizione per vedere operatori e offerte disponibili nella tua zona.",
      allowLocationSharing: "Consenti condivisione posizione",
      orSelectRegion: "o seleziona la tua regione",
    },
    providers: {
      title: "Scegli i tuoi operatori",
      subtitle: "Scegli i tuoi operatori per trend e quote personalizzati e un'esperienza betslip più fluida.",
      emptyCta: "Non ne ho ancora uno",
    },
    odds: {
      title: "Scegli il formato delle quote",
      subtitle: "Visualizza le quote nel formato con cui ti trovi meglio per decisioni più rapide e semplici.",
    },
    socialProof: {
      title: "Scelto da scommettitori ovunque",
      subtitle: "Dagli utenti alle prime armi agli scommettitori quotidiani, Linemate offre insight più intelligenti su larga scala",
      reviewer: "Recensore App Store",
      reviews: {
        review1: {
          title: "Davvero l'app meglio progettata che abbia incontrato da un po'.",
          text: "Tutto è esattamente dove deve essere, le funzioni funzionano come previsto, è un'app molto curata e ricca di informazioni, ma efficiente e organizzata. Da appassionato di statistiche, faccio i complimenti a Linemate per il design e la facilità nel trovare buone giocate."
        },
        review2: {
          title: "La migliore app di tutte",
          text: "È al 100% la migliore app per scommesse sportive... dopo averla provata per qualche giorno mi ha convinto. Consiglio molto la versione a pagamento per sfruttare tutto ciò che offre. Non resterai deluso! Scaricala con fiducia e goditela!"
        },
        review3: {
          title: "La migliore",
          text: "Ho provato molte app di statistiche. Linemate è quella a cui continuo a tornare. Offre tantissimo gratis, aggiunge funzionalità senza togliere nulla, e il piano Plus vale il prezzo. Il supporto ha risposto in 5 minuti. Si vede che vogliono essere l'app di riferimento. Consigliatissima."
        },
        review4: {
          title: "Piacevolmente sorpreso",
          text: "Se sei nuovo e segui le props alla cieca, i risultati varieranno: serve comunque strategia. Ho scaricato Linemate dopo che i miei parlay mancavano per poco, e il mio primo parlay di 7 leg su props giocatore è entrato. Per 10 $/mese, con la prima settimana gratis, ne vale decisamente la pena. Non sarà perfetta, ma fa gran parte del lavoro pesante."
        },
        review5: {
          title: "Ottima app!",
          text: "Nessuna app di scommesse è mai al 100%, ma questa finora mi ha dato i risultati migliori. Sono tutte statistiche e dati reali. La versione gratuita è solida, e l'abbonamento è ancora meglio: puoi recuperarlo facilmente con questa app."
        },
        review6: {
          title: "Ottima app che si distingue",
          text: "Ottima app che si distingue davvero, accessibile e con funzioni forti per la ricerca. Nel complesso, lavoro fantastico, continuate così."
        },
      },
    },
    summary: {
      title: "Il tuo profilo è pronto",
      subtitle: "Abbiamo personalizzato l'app in base alle tue scelte. Crea il profilo per salvarlo e iniziare.",
      leagues: "Le tue leghe",
      location: "La tua posizione",
      oddsFormat: "Il tuo formato quote",
      operators: "I tuoi operatori",
      noOperators: "Nessun operatore",
    },
    consent: {
      title: "Rimani aggiornato",
      subtitle: "Ricevi aggiornamenti su funzionalità, miglioramenti e offerte. Puoi annullare l'iscrizione in qualsiasi momento.",
      emailToggle: "Ricevi aggiornamenti e offerte esclusive via email",
      pushToggle: "Attiva notifiche per insight in tempo reale",
      confirm: "Conferma le mie scelte",
    },
  },
};